var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "90px",
    viewBox: "0 0 96 90",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "03") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M89.0896,30.3317837 L89.0896,70.0464836 C89.0896,70.2143464 89.0896,70.2986872 89.0896,70.46655 C89.008,72.7331072 87.9384,74.7482796 86.3752,76.0920008 C84.9768,77.3513812 83.1672,78.1071732 81.1928,78.1071732 L18.5912,78.1071732 C17.1928,78.1071732 15.9592,77.7714476 14.8072,77.0999964 C14.3136,76.8477928 13.82,76.5120672 13.4088,76.0920008 C12.504,75.3362088 11.7632,74.329032 11.352,73.1531736 C11.0232,72.3138596 10.776,71.4737268 10.776,70.550072 L10.776,30.3317837 C10.776,30.3317837 14.0672,27.4772973 18.756,23.5312934 C23.6096,19.3330858 30.0256,13.9590198 35.6192,9.17288297 C38.828,6.40273741 38.4984,6.738463 43.4344,2.45591459 C47.2184,-0.818638198 52.7304,-0.818638198 56.5144,2.45591459 C57.5016,3.29604742 58.4888,4.21970222 59.476,5.0590162 C61.532,6.738463 63.8352,8.7536354 66.2208,10.7688078 C71.2392,15.0505374 76.7504,19.7523333 81.1104,23.4469525 C85.5528,27.2250937 88.7608,29.9960581 89.0896,30.3317837 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-14.0%",
    y: "-9.0%",
    width: "128.1%",
    height: "128.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.11372549   0 0 0 0 0.294117647   0 0 0 0 1  0 0 0 0.22 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.0762029175%",
    y1: "50.7140369%",
    x2: "99.7532477%",
    y2: "50.7140369%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F53689",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9385083%",
    y1: "131.492873%",
    x2: "49.9385083%",
    y2: "6.62265566%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6AFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#657EFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.16276611%",
    y1: "49.9545805%",
    x2: "102.080294%",
    y2: "49.9545805%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "55.7319046%",
    y1: "53.7217398%",
    x2: "47.9781642%",
    y2: "46.3283225%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F6AFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#657EFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "95.757973%",
    y1: "49.9545805%",
    x2: "-3.2388664%",
    y2: "49.9545805%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.233405241%",
    y1: "50.2216312%",
    x2: "99.9964636%",
    y2: "50.2216312%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-0.233405241%",
    y1: "48.1382979%",
    x2: "99.9964636%",
    y2: "48.1382979%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A78FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Resellers",
    transform: "translate(-277.000000, -1134.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 3,
    transform: "translate(277.000000, 1136.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7688,86 C72.3488,86 90.6528,67.3164614 90.6528,44.2701277 C90.6528,21.2229752 72.3488,2.54025541 49.7688,2.54025541 C27.1888,2.54025541 8.884,21.2229752 8.884,44.2701277 C8.884,67.3164614 27.1888,86 49.7688,86 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#526DFF",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.1104,23.4469525 L81.1104,37.7210221 L67.4552,46.1174373 L63.3416,48.6361981 L54.704,53.9259233 L50.5912,56.4446841 L48.864,57.5362017 L47.2184,56.4446841 L43.352,53.9259233 L35.1256,48.6361981 L31.26,46.1174373 L18.5912,37.9724069 L18.5912,23.5312934 C23.4448,19.3330858 29.8608,13.9590198 35.4552,9.17288297 L66.0568,10.7688078 C71.3216,15.0505374 76.8328,19.7523333 81.1104,23.4469525 Z",
    id: "Path",
    fill: "#465DD9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.396,12.1117102 L78.396,37.1330929 L65.892,44.7737161 L62.1904,47.0410921 L54.2928,51.8264101 L50.5912,54.0937861 L49.028,55.0174409 L47.5472,54.0937861 L44.0104,51.8264101 L36.5248,47.0410921 L32.9872,44.7737161 L21.4704,37.3852965 L21.4704,12.1117102 C21.4704,9.50942741 23.5272,7.32639221 26.1592,7.32639221 L73.7072,7.32639221 C76.2568,7.32639221 78.396,9.50942741 78.396,12.1117102 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1952,25.8821914 L33.0696,25.8821914 C32.4936,25.8821914 32,25.3777841 32,24.7063329 C32,24.0348818 32.4936,23.5312934 33.0696,23.5312934 L68.1952,23.5312934 C68.7712,23.5312934 69.2648,24.0348818 69.2648,24.7063329 C69.2648,25.3777841 68.7712,25.8821914 68.1952,25.8821914 Z",
    id: "Path",
    fill: "#E7EBF2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1952,32.9348853 L33.0696,32.9348853 C32.4936,32.9348853 32,32.4312969 32,31.7590269 C32,31.0875757 32.4936,30.5839873 33.0696,30.5839873 L68.1952,30.5839873 C68.7712,30.5839873 69.2648,31.0875757 69.2648,31.7590269 C69.2648,32.4312969 68.7712,32.9348853 68.1952,32.9348853 Z",
    id: "Path",
    fill: "#E7EBF2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1952,39.9875793 L33.0696,39.9875793 C32.4936,39.9875793 32,39.4839909 32,38.8125397 C32,38.1402697 32.4936,37.6366813 33.0696,37.6366813 L68.1952,37.6366813 C68.7712,37.6366813 69.2648,38.1402697 69.2648,38.8125397 C69.2648,39.4839909 68.7712,39.9875793 68.1952,39.9875793 Z",
    id: "Path",
    fill: "#E7EBF2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E7EBF2",
    fillRule: "nonzero",
    points: "65.892 44.7737161 62.1904 47.0410921 36.5248 47.0410921 32.9872 44.7737161 33.0696 44.7737161"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E7EBF2",
    fillRule: "nonzero",
    points: "54.2928 51.8264101 50.5912 54.1773081 47.5472 54.1773081 44.0104 51.8264101"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.6272,17.8215018 L40.72,17.8215018 C40.144,17.8215018 39.6504,17.3179134 39.6504,16.6456434 C39.6504,15.9741922 40.144,15.4706038 40.72,15.4706038 L60.6272,15.4706038 C61.2032,15.4706038 61.6968,15.9741922 61.6968,16.6456434 C61.6968,17.3179134 61.2032,17.8215018 60.6272,17.8215018 Z",
    id: "Path",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1056,30.1639209 L48.6992,32.6826817 L88.5144,30.1639209 L87.0336,37.4688185 C87.0336,37.4688185 49.604,57.4518608 49.8512,57.4518608 C50.0976,57.4518608 11.188,33.7741993 11.188,33.7741993 L11.1056,30.1639209 Z",
    id: "Path",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero",
    opacity: 0.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0896,30.3317837 L89.0896,70.46655 C89.008,72.733926 87.9384,74.7482796 86.3752,76.0920008 C84.9768,77.3513812 83.1672,78.1071732 81.1928,78.1071732 L18.5912,78.1071732 C17.1928,78.1071732 15.9592,77.7714476 14.8072,77.0999964 C14.3136,76.8477928 13.82,76.5120672 13.4088,76.0920008 C12.504,75.3362088 11.7632,74.329032 11.352,73.1531736 C11.0232,72.3138596 10.776,71.4737268 10.776,70.5508908 L10.776,70.46655 L10.776,30.3317837 L45.82,52.7500649 L48.864,54.6817153 L49.9328,54.0094453 L50.92,53.4223349 L89.0896,30.3317837 Z",
    id: "Path",
    fill: "#738DFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4576,76.0920008 C85.0592,77.3513812 83.2496,78.1071732 81.2752,78.1071732 L18.5912,78.1071732 C17.1928,78.1071732 15.9592,77.7714476 14.8072,77.0999964 C14.3136,76.8477928 13.82,76.5120672 13.4088,76.0920008 C12.504,75.3362088 11.7632,74.329032 11.352,73.1531736 C11.0232,72.3138596 10.776,71.4737268 10.776,70.5508908 L10.776,70.46655 L10.776,30.3317837 L14.8896,32.8505445 L49.9328,54.0937861 L50.92,54.6817153 L51.0024,54.7652373 L82.4264,73.7411028 L86.4576,76.0920008 Z",
    id: "Path",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.92,53.4223349 L50.92,56.1924805 L14.8072,77.0999964 C14.3136,76.8477928 13.82,76.5120672 13.4088,76.0920008 C12.504,75.3362088 11.7632,74.329032 11.352,73.1531736 L46.4784,51.9107509 L49.5216,53.8415825 L49.9328,54.0094453 L50.92,53.4223349 Z",
    id: "Path",
    fill: "url(#linearGradient-6)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.776,
    y1: 30.3317837,
    x2: 49.9328,
    y2: 54.0937861,
    id: "Path",
    stroke: "#A6BDFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.0896,30.3317837 L89.0896,70.46655 C89.008,72.733926 87.9384,74.7482796 86.3752,76.0920008 C84.9768,77.3513812 83.1672,78.1071732 81.1928,78.1071732 L18.5912,78.1071732 C17.1928,78.1071732 15.9592,77.7714476 14.8072,77.0999964 C14.3136,76.8477928 13.82,76.5120672 13.4088,76.0920008 L17.4392,73.656762 L48.864,54.6817153 L49.9328,54.0094453 L50.92,53.4223349 L84.9768,32.7670225 L89.0896,30.3317837 Z",
    id: "Path",
    fill: "url(#linearGradient-7)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    stroke: "#99B3FF",
    strokeWidth: 0.5,
    points: "89.0896 30.3317837 50.92 53.4223349 49.9328 54.0094453 48.864 54.6817153 13.4088 76.0920008"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.712,58.3755156 L58.9,58.3755156 C58.4064,58.3755156 57.9952,57.9562681 57.9952,57.4518608 C57.9952,56.9482725 58.4064,56.528206 58.9,56.528206 L79.712,56.528206 C80.2056,56.528206 80.6168,56.9482725 80.6168,57.4518608 C80.6168,57.9562681 80.2056,58.3755156 79.712,58.3755156 Z",
    id: "Path",
    fill: "url(#linearGradient-8)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.712,64.5053737 L58.9,64.5053737 C58.4064,64.5053737 57.9952,64.0853072 57.9952,63.5817189 C57.9952,63.0781305 58.4064,62.6580641 58.9,62.6580641 L79.712,62.6580641 C80.2056,62.6580641 80.6168,63.0781305 80.6168,63.5817189 C80.6168,64.0853072 80.2056,64.5053737 79.712,64.5053737 Z",
    id: "Path",
    fill: "url(#linearGradient-9)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.8744,26.5536425 C94.6008,26.5536425 96,25.1255805 96,23.3634306 C96,21.6012806 94.6008,20.1723998 92.8744,20.1723998 C91.1472,20.1723998 89.748,21.6012806 89.748,23.3634306 C89.748,25.1255805 91.1472,26.5536425 92.8744,26.5536425 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6944,14.8826746 C11.8296,14.8826746 12.7504,13.9426429 12.7504,12.7839802 C12.7504,11.6244986 11.8296,10.684467 10.6944,10.684467 C9.5584,10.684467 8.6376,11.6244986 8.6376,12.7839802 C8.6376,13.9426429 9.5584,14.8826746 10.6944,14.8826746 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.3984,20.2567406 C2.1712,20.2567406 2.7968,19.6172243 2.7968,18.8286785 C2.7968,18.0409517 2.1712,17.4014354 1.3984,17.4014354 C0.6264,17.4014354 0,18.0409517 0,18.8286785 C0,19.6172243 0.6264,20.2567406 1.3984,20.2567406 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.2544,13.035365 C89.9816,13.035365 90.5704,12.4343343 90.5704,11.6924626 C90.5704,10.9505909 89.9816,10.3487414 89.2544,10.3487414 C88.5272,10.3487414 87.9384,10.9505909 87.9384,11.6924626 C87.9384,12.4343343 88.5272,13.035365 89.2544,13.035365 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5192,56.7804097 C95.2464,56.7804097 95.8352,56.179379 95.8352,55.4366884 C95.8352,54.6948168 95.2464,54.0937861 94.5192,54.0937861 C93.7928,54.0937861 93.2032,54.6948168 93.2032,55.4366884 C93.2032,56.179379 93.7928,56.7804097 94.5192,56.7804097 Z",
    id: "Path",
    fill: "#EAEEF9",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9768,32.7670225 L84.9768,36.9652301 L89.0896,34.8657169 L89.0896,30.3317837 L84.9768,32.7670225 Z M84.9768,53.5058569 L84.9768,60.3071661 L89.0896,58.2076528 L89.0896,51.4071625 L84.9768,53.5058569 Z M84.9768,65.092484 L84.9768,70.2986872 C84.8944,70.8866164 84.7304,71.5580676 84.4008,72.061656 C84.3184,72.1459968 84.3184,72.2295188 84.2368,72.3138596 L89.0896,69.7950988 L89.0896,62.9937896 L84.9768,65.092484 Z M83.9896,77.2678592 L82.756,77.9393104 C84.1544,77.6871068 85.3056,77.0156556 86.3752,76.1763416 C86.3752,76.1763416 86.3752,76.1763416 86.4576,76.1763416 C86.54,76.1763416 86.54,76.0920008 86.6224,76.0084788 L83.9896,77.2678592 Z M10.776,64.8410992 L10.776,70.46655 L10.776,70.5508908 C10.776,70.8866164 10.8584,71.222342 10.9408,71.5580676 L14.8896,69.4593733 L14.8896,62.6580641 L10.776,64.8410992 Z M10.776,41.4991633 L10.776,48.3004725 L14.8896,46.2009593 L14.8896,39.4004689 L10.776,41.4991633 Z M10.776,30.3317837 L10.776,36.7130265 L14.8896,34.6143321 L14.8896,32.8505445 L10.776,30.3317837 Z M10.776,53.1701313 L10.776,59.9714405 L14.8896,57.8719273 L14.8896,51.0706181 L10.776,53.1701313 Z M18.5912,73.9089656 C18.18,73.9089656 17.7688,73.8254436 17.44,73.7411028 C17.1928,73.656762 17.028,73.57324 16.7816,73.4888992 C16.7816,73.4888992 16.7816,73.4888992 16.6992,73.4888992 L12.7504,75.5884124 C12.9976,75.8397972 13.1616,76.0084788 13.4088,76.2598636 C13.82,76.67993 14.3136,76.9313148 14.8072,77.2678592 C15.136,77.519244 15.5472,77.6871068 15.9592,77.7714476 L23.6096,73.9933064 L18.5912,73.9933064 L18.5912,73.9089656 Z M33.9744,73.9089656 L25.3368,78.1071732 L34.7144,78.1071732 L43.352,73.9089656 L33.9744,73.9089656 Z M53.5528,73.9089656 L44.9152,78.1071732 L54.2928,78.1071732 L62.9304,73.9089656 L53.5528,73.9089656 Z M73.2136,73.9089656 L64.576,78.1071732 L72.144,78.1071732 L80.7816,73.9089656 L73.2136,73.9089656 Z M84.9768,41.8348889 L84.9768,48.6361981 L89.0896,46.5366849 L89.0896,39.7361945 L84.9768,41.8348889 Z",
    id: "Shape",
    fill: "#526DFF",
    fillRule: "nonzero",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9896,77.2678592 L86.54,75.924138 C86.4576,76.0084788 86.4576,76.0084788 86.3752,76.0920008 C86.3752,76.0920008 86.3752,76.0920008 86.2928,76.0920008 L83.9896,77.2678592 Z",
    id: "Path",
    fill: "#526DFF",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip);
export default __webpack_public_path__ + "static/media/vip.5cca5680b665d59e504302ab931a08f4.svg";
export { ForwardRef as ReactComponent };